import useApi from 'common/hooks/useApi';
import useThunkDispatch from 'common/hooks/useThunkDispatch';
import useTypedSelector from 'common/hooks/useTypedSelector';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import FormVerificationResponse from 'domain/components/verify-identity/FormVerificationResponse';
import ProfileVerificationStatusCd from 'domain/enums/ProfileVerificationStatusCd';
import { fetchRegisteredApps } from 'features/registration/RegistrationsSlice';
import { useEffect, useState } from 'react';
import AddRegistrationNumberPresenter from './AddRegistrationNumberPresenter';
import AddRegistrationRequest from 'domain/types/AddRegistrationRequest';

interface IAddRegistrationNumberContainer {
  isSidebar?: boolean;
}

function AddRegistrationNumber(props: IAddRegistrationNumberContainer) {
  const { meta, profileAddress } = useTypedSelector((state) => ({
    meta: state.registeredApps.meta,
    profileAddress: state.profile.data.address,
  }));
  const [isOpen, setOpen] = useState(false);
  const dispatch = useThunkDispatch();

  const [{ loading: submitLoading, error }, request] =
    useApi<ActionCompleteResponse>({
      url: '/applications/addExistingRegistration',
      method: 'POST',
    });
  const [
    { data: formVerificationData, loading: formVerificationLoading },
    fetchVerification,
  ] = useApi<FormVerificationResponse>({
    url: `/profile/formVerification`,
    method: 'GET',
  });

  // Fetch verification each time the modal opens
  useEffect(() => {
    if (!isOpen) return;
    fetchVerification();
  }, [fetchVerification, isOpen]);

  const onSubmit = (req: AddRegistrationRequest) => {
    request(req).then((res) => {
      if (!res.error) {
        setOpen(false);
        dispatch(
          fetchRegisteredApps({
            pageNum: meta.pagination.currentPage,
            pageSize: meta.pagination.itemsPerPage,
            sortBy: meta.sortBy,
            sortDir: meta.sortDir,
          })
        );
      }
    });
  };

  return (
    <AddRegistrationNumberPresenter
      isOpen={isOpen}
      setOpen={setOpen}
      identity={{
        rejected:
          formVerificationData?.status !== null &&
          formVerificationData?.status === ProfileVerificationStatusCd.REJECTED,
        uploaded:
          formVerificationData?.status !== null &&
          formVerificationData?.status !== ProfileVerificationStatusCd.INITIAL,
        loading: formVerificationLoading,
      }}
      profileAddress={profileAddress}
      loading={submitLoading}
      onSubmit={onSubmit}
      submitError={error}
      isSidebar={props.isSidebar}
    />
  );
}

export default AddRegistrationNumber;
